module.exports = __webpack_public_path__ + "static/img/yangan2.ccafa2bb.png";